<template>
    <div>
        <div class="enquiry-form" v-if="!sendingEnquiry.status">
            <p>If you have a question or request, please complete and submit this form.</p>
            <div class="form-group">
                <label>Subject* <small>(maximum of 200 characters are allowed)</small></label>
                <input
                    v-model="formData.enquirySubject"
                    type="text"
                    class="form-control"
                    placeholder="Reason for your enquiry"
                    maxlength="200"
                    :class="{ invalid: errors.failingOn.includes('enquirySubject') || subjectLength >= 200 }"
                />
                <div class="error-messages" v-show="subjectLength >= 200">Character limit reached</div>
            </div>
            <div class="form-group">
                <label>Contact Number*</label>

                <input
                    v-model="formData.enquiryPhone"
                    type="text"
                    class="form-control"
                    placeholder
                    maxlength="20"
                    :class="{ invalid: errors.failingOn.includes('enquiryPhone') || phoneLength >= 20 || hasInvalidChars && phoneLength}"
                />
                <div class="error-messages" v-show="phoneLength >= 20">Character limit reached</div>
                <div class="error-messages" v-show="hasInvalidChars && phoneLength">Only <code>+.-() 01234567890</code> characters are valid</div>
            </div>
            <div class="form-group">
                <label>Enquiry* <small>(maximum of 1000 characters are allowed)</small></label>
                <textarea
                    rows="10"
                    v-model="formData.enquiryBody"
                    maxlength="1000"
                    class="form-control theme-input"
                    :class="{ invalid: errors.failingOn.includes('enquiryBody') || enquiryLength >= 1000 }"
                />
                <div class="error-messages" v-show="enquiryLength >= 1000">Character limit reached</div>
            </div>
            <div class="error-messages" v-show="!errors.passed">Some fields above have errors and are highlighted. Please complete them and try again</div>
            <div class="action-wrapper">
                <div
                    class="button-outline-rounded small text-center mt-2"
                    @click="submitEnquiry"
                    @keyup.enter="submitEnquiry"
                    @keyup.space="submitEnquiry"
                    tabindex="0"
                    role="button"
                    aria-pressed="false"
                >
                    Submit enquiry
                    <span class="icon-mail"></span>
                </div>
            </div>
        </div>
        <div v-else class="loader" style="min-height: 260px">
            <mini-loader :message="sendingEnquiry.message" />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import miniLoader from '@/components/layout/miniLoader.vue';

export default {
    data () {
        return {
            sendingEnquiry: {
                status: false,
                message: {
                    header: 'Sending enquiry...',
                    body: '<p>Submitting enquiry<p>',
                },
            },
            errors: {
                passed: true,
                failingOn: [],
            },
            formData: {
                enquirySubject: '',
                enquiryPhone: this.$store.state.ui.dashboardData && this.$store.state.ui.dashboardData.basicData && this.$store.state.ui.dashboardData.basicData.phoneNumbers ? (this.$store.state.ui.dashboardData.basicData.phoneNumbers.Mobile || this.$store.state.ui.dashboardData.basicData.phoneNumbers.Home) : '',
                enquiryBody: '',
            },
        };
    },
    components: {
        miniLoader,
    },
    created () {
        if (!this.$store.state.ui.dashboardData) {
            this.$router.push('/my-pension/my-data'); // push to dashboard to populate data
        }
    },
    computed: {
        clientConfig () {
            return this.$store.getters['clientConfig/clientConfig'];
        },
        enquiryLength () {
            return this.formData.enquiryBody.length;
        },
        subjectLength () {
            return this.formData.enquirySubject.length;
        },
        phoneLength () {
            return this.formData.enquiryPhone.length;
        },
        hasInvalidChars () {
            const telRegex = /^[0-9.\-\s+()]+$/g; // #14528, #8463 allow '0-9 +().-' chars in phone number
            return !telRegex.test(this.formData.enquiryPhone);
        },
    },
    methods: {
        submitEnquiry () {
            this.errors = {
                passed: true,
                failingOn: [],
            };
            // validate for non empty fields
            const fieldsToValidate = ['enquirySubject', 'enquiryPhone', 'enquiryBody'];
            const rawData = this.formData;
            fieldsToValidate.forEach((key) => {
                const stringValue = rawData[key];
                if (stringValue.trim() === '' || stringValue === null) {
                    this.errors.passed = false;
                    this.errors.failingOn.push(key);
                }
                if (key === 'enquiryPhone') {
                    if (this.hasInvalidChars || rawData[key].length < 10) {
                        this.errors.passed = false;
                        this.errors.failingOn.push(key);
                    }
                }
            });
            if (this.errors.passed) {
                const formData = {
                    Subject: this.formData.enquirySubject,
                    Phone: this.formData.enquiryPhone,
                    Message: this.formData.enquiryBody,
                };
                const code = process.env.VUE_APP_APICODE;
                const apiUrl = process.env.VUE_APP_APIADDRESS;
                this.sendingEnquiry.status = true;
                axios.post(`${apiUrl}/WebMessage?code=${code}`, { data: JSON.stringify(formData), queryType: 'General' }).then((response) => {
                    this.sendingEnquiry.message = {
                        header: response.data.success ? 'Success' : 'Error',
                        body: response.data.success
                            ? `<p>Thank you for your enquiry.  We aim to respond to you within the next 10 working days.  If your enquiry is particularly urgent, please phone us on <a href="tel:${this.clientConfig.telephoneBasic}">${this.clientConfig.telephoneInt}</a></p>`
                            : `<p>${response.data.message}</p>`,
                    };
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
code {
    color: inherit;
}
</style>
